import React from 'react';

export default function NotFound() {
    return <h2>404</h2>;
}